export const RESEND_TIME = 60000; // 60000 milliseconds = 1 minute
export const OTP_PATTERN = /^\d+\.?\d*$/;
export const RESEND_LIMIT = 3;
export const OTP_LENGTH = 6;
export const OTP_VALIDATION_LIMIT = 4;
